import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import React from 'react';
import UserAvatarPopover from '../AvatarPopover';
import { ResourceType } from '../../types/resource';
import { BiData } from '@wix/da-bi/pkg/events';
export const UserLinkPopover = ({ user , className , relatedItemBiData , biData , children  })=>{
    // TODO: use isGroup util function
    return /*#__PURE__*/ React.createElement(UserAvatarPopover, {
        username: user.username,
        className: className,
        relatedItemBiData: relatedItemBiData,
        biData: BiData(_object_spread({
            evid: 107,
            itemid: user.userId,
            typeid: user.type.includes('group') ? ResourceType.GROUP : ResourceType.USER
        }, biData))
    }, children);
};
UserLinkPopover.displayName = 'UserLinkPopover';
export default UserLinkPopover;
